import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { GoBackComponent } from 'shared/components/go-back/go-back.component';
import { TranslateModule } from '@ngx-translate/core';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { CurrencyPipe } from '@angular/common';
import { LinkifyPipe } from '../core/pipes/linkify.pipe';
import { NzTableModule } from 'ng-zorro-antd/table';

interface IFee {
  localizableName: string;
  amount: number;
  localizableDescription: string;
}

interface IFeesListItem {
  localizableTitle: string;
  fees: IFee[];
}

@Component({
  selector: 'app-your-documentation',
  templateUrl: './your-documentation.component.html',
  styleUrl: './your-documentation.component.scss',
  standalone: true,
  imports: [GoBackComponent, TranslateModule, NzCollapseModule, CurrencyPipe, LinkifyPipe, NzTableModule]
})
export class YourDocumentationComponent {
  public feesList: IFeesListItem[] = [
    {
      localizableTitle: 'okeeyCash.standard_fees.title',
      fees: [
        {
          localizableName: 'okeeyCash.standard_fees.fees.card_purchase_fee.title',
          amount: 10.0,
          localizableDescription: 'okeeyCash.standard_fees.fees.card_purchase_fee.description'
        },
        {
          localizableName: 'okeeyCash.standard_fees.fees.signature_purchase.title',
          amount: 0.0,
          localizableDescription: 'okeeyCash.standard_fees.fees.signature_purchase.description'
        },
        {
          localizableName: 'okeeyCash.standard_fees.fees.pin_purchase.title',
          amount: 0.0,
          localizableDescription: 'okeeyCash.standard_fees.fees.pin_purchase.description'
        },
        {
          localizableName: 'okeeyCash.standard_fees.fees.atm_withdrawal_domestic.title',
          amount: 2.5,
          localizableDescription: 'okeeyCash.standard_fees.fees.atm_withdrawal_domestic.description'
        },
        {
          localizableName: 'okeeyCash.standard_fees.fees.cash_back_pos.title',
          amount: 0.5,
          localizableDescription: 'okeeyCash.standard_fees.fees.cash_back_pos.description'
        }
      ]
    },
    {
      localizableTitle: 'okeeyCash.transfer_fees.title',
      fees: [
        {
          localizableName: 'okeeyCash.transfer_fees.fees.direct_deposit.title',
          amount: 0.0,
          localizableDescription: 'okeeyCash.transfer_fees.fees.direct_deposit.description'
        },
        {
          localizableName: 'okeeyCash.transfer_fees.fees.bank_to_card_transfer.title',
          amount: 0.0,
          localizableDescription: 'okeeyCash.transfer_fees.fees.bank_to_card_transfer.description'
        },
        {
          localizableName: 'okeeyCash.transfer_fees.fees.card_to_card_transfer.title',
          amount: 0.5,
          localizableDescription: 'okeeyCash.transfer_fees.fees.card_to_card_transfer.description'
        },
        {
          localizableName: 'okeeyCash.transfer_fees.fees.card_to_bank_transfer.title',
          amount: 1.5,
          localizableDescription: 'okeeyCash.transfer_fees.fees.card_to_bank_transfer.description'
        }
      ]
    },
    {
      localizableTitle: 'okeeyCash.outside_us_card_use.title',
      fees: [
        {
          localizableName: 'okeeyCash.outside_us_card_use.fees.international_transaction_pin.title',
          amount: 0.5,
          localizableDescription: 'okeeyCash.outside_us_card_use.fees.international_transaction_pin.description'
        },
        {
          localizableName: 'okeeyCash.outside_us_card_use.fees.international_transaction_signature.title',
          amount: 0.0,
          localizableDescription: 'okeeyCash.outside_us_card_use.fees.international_transaction_signature.description'
        },
        {
          localizableName: 'okeeyCash.outside_us_card_use.fees.international_atm_withdrawal.title',
          amount: 2.5,
          localizableDescription: 'okeeyCash.outside_us_card_use.fees.international_atm_withdrawal.description'
        },
        {
          localizableName: 'okeeyCash.outside_us_card_use.fees.international_atm_balance_inquiry.title',
          amount: 0.5,
          localizableDescription: 'okeeyCash.outside_us_card_use.fees.international_atm_balance_inquiry.description'
        }
      ]
    },
    {
      localizableTitle: 'okeeyCash.card_specific_fees.title',
      fees: [
        {
          localizableName: 'okeeyCash.card_specific_fees.fees.cash_reload.title',
          amount: 4.99,
          localizableDescription: 'okeeyCash.card_specific_fees.fees.cash_reload.description'
        },
        {
          localizableName: 'okeeyCash.card_specific_fees.fees.customer_service.title',
          amount: 0.0,
          localizableDescription: 'okeeyCash.card_specific_fees.fees.customer_service.description'
        },
        {
          localizableName: 'okeeyCash.card_specific_fees.fees.atm_balance_inquiry_decline.title',
          amount: 0.5,
          localizableDescription: 'okeeyCash.card_specific_fees.fees.atm_balance_inquiry_decline.description'
        },
        {
          localizableName: 'okeeyCash.card_specific_fees.fees.inactivity.title',
          amount: 1.0,
          localizableDescription: 'okeeyCash.card_specific_fees.fees.inactivity.description'
        }
      ]
    }
  ];

  public onOkeeyCashWebsiteClick(): void {
    window.open('https://okeey-cash-usa.bahumobile.com/en/', '_blank');
  }

  public onCardHolderAgreementClick(lang: 'es' | 'en'): void {
    window.open(`https://okeey-cash-usa.bahumobile.com/en/assets/documents/doc4_${lang}.pdf`, '_blank');
  }
}
